export const Hami_Agreement_Id = 'Hami';
export const Wallet_Agreement_Code = 'WalletContract';
export const Option_Agreement_Id = 'd08c80d2-7e90-4cab-8dd9-3852f0ca2701';
